module.exports = __webpack_public_path__ + "static/media/pathfinder.040ba62b.jpg";